import { render, staticRenderFns } from "./LayoutContentRendererLeftDetached.vue?vue&type=template&id=be1a354e&"
import script from "./LayoutContentRendererLeftDetached.vue?vue&type=script&lang=js&"
export * from "./LayoutContentRendererLeftDetached.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports